import { render, staticRenderFns } from "./ResubmissionRedirectStepOne.vue?vue&type=template&id=361836ba&scoped=true&"
import script from "./ResubmissionRedirectStepOne.vue?vue&type=script&lang=js&"
export * from "./ResubmissionRedirectStepOne.vue?vue&type=script&lang=js&"
import style0 from "./ResubmissionRedirectStepOne.vue?vue&type=style&index=0&id=361836ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361836ba",
  null
  
)

export default component.exports